import { FC, ReactNode } from 'react';

import { Box, rem } from '@bonusly/design-system';

const baseStyle = {
	bg: 'none',
	color: 'secondary.fg',
	_hover: { bg: 'secondary.bgAlpha' },
	cursor: 'pointer',
};

type UserNavActionProps = {
	children: ReactNode;
	isExpanded: boolean;
	onClick: () => void;
};

export const UserNavAction: FC<UserNavActionProps> = ({ children, isExpanded, onClick, ...props }) => {
	return (
		<Box
			as="button"
			type="button"
			onClick={onClick}
			w="100%"
			py={rem(8)}
			px={isExpanded ? rem(10) : rem(8)}
			borderRadius="md"
			textAlign="left"
			{...baseStyle}
			{...props}
		>
			{children}
		</Box>
	);
};
